import extend from '@/utils/vuex-extend';
import {dialog} from '@/vuex-extend';
import {getOrderDetail, getReturnReasonList} from '@/api/oms/order';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';
import {fetchDetail, returnOrderInStock} from "@/api/oms/return-instock";

export default extend(dialog, {
	namespaced: true,
	state: {
		detail: {},
		list: [],
		returnSerialNumber: 0
	},
	actions: {
		async afterOpenDialog({dispatch, commit, state}, payload) {
			const {returnSerialNumber} = state;
			await wait(dispatch, 'oms.return-instock.detail', async function () {
				let response = await fetchDetail({returnSerialNumber});
				if (response.data) {
					commit('save', {
						detail: response.data,
						list: (response.data.returnGoodsList || []).map((v) => {
							return {
								...v,
								storageLocation: '',
								inStockNum: ''
							}
						})
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							dispatch('closeDialog')
						}
					})
				}
			})
		},
		// async returnOrderInStock({dispatch, commit, state}, payload){
		// 	const {returnSerialNumber} = state;
		// 	await wait(dispatch, 'oms.return-instock.detail', async function () {
		// 		let response = await returnOrderInStock({returnSerialNumber});
		// 		if (response.data) {
		// 			commit('save', {
		// 				detail: response.data
		// 			})
		// 		} else {
		// 			Message.error({
		// 				message: '无此订单',
		// 				onClose: () => {
		// 					dispatch('closeDialog')
		// 				}
		// 			})
		// 		}
		// 	})
		// }
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/return-instock/detail.js